import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SingleDatePicker } from 'react-dates';
import map from 'lodash/map';
import moment from 'moment';

// Import default styles
import 'react-dates/lib/css/_datepicker.css';

const meridiems = ['AM', 'PM'];
const hours = ['12', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11'];
const halfHours = [':00', ':30'];

class DateTimePicker extends Component {
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    onChange: PropTypes.func,
  };

  constructor(props) {
    super(props);

    const date = props.value ? moment(props.value) : null;

    this.state = {
      focused: false,
      selectedDate: date,
      selectedTime: date ? date.format('hh:mmA') : null,
    };
  }

  onChange = () => {
    const { selectedDate, selectedTime } = this.state;

    if (selectedDate && selectedTime) {
      let hour = parseInt(selectedTime.substr(0, 2), 10);

      if (selectedTime.substr(0, 2) === '12') {
        hour = 0;
      }

      if (selectedTime.substr(5, 2) === 'PM') {
        hour += 12;
      }

      this.props.onChange(
        moment(selectedDate)
          .hour(hour)
          .minute(parseInt(selectedTime.substr(3, 2), 10))
      );
    } else {
      this.props.onChange(null);
    }
  };

  onDateChange = date => {
    this.setState({ selectedDate: date }, this.onChange);
  };

  onSelectTime = event => {
    this.setState({ selectedTime: event.target.value }, this.onChange);
  };

  render() {
    const { selectedDate, selectedTime } = this.state;

    const times = [];

    for (let i = 0; i < meridiems.length; i++) {
      for (let j = 0; j < hours.length; j++) {
        for (let k = 0; k < halfHours.length; k++) {
          times.push(`${hours[j]}${halfHours[k]}${meridiems[i]}`);
        }
      }
    }

    return (
      <div className="date-time-picker">
        <SingleDatePicker
          id="date_input"
          date={selectedDate}
          onDateChange={this.onDateChange}
          reopenPickerOnClearDate
          focused={this.state.focused}
          onFocusChange={({ focused }) => {
            this.setState({ focused });
          }}
          showClearDate={false}
        />
        <select onChange={this.onSelectTime} value={selectedTime || ''}>
          <option value='Time' hidden>Time</option>
          {map(times, (time, i) => (
            <option key={i} value={time}>
              {time}
            </option>
          ))}
        </select>
      </div>
    );
  }
}

export default DateTimePicker;



// WEBPACK FOOTER //
// ./src/common/components/DateTimePicker.js